import { gql } from '@apollo/client'
import { CHATBOT_CONVERSATION_FIELDS } from './fragments/chatbot_conversation'

export const UPDATE_CHATBOT_CONVERSATION = gql`
  ${CHATBOT_CONVERSATION_FIELDS}
  mutation updateChatbotConversation($id: ID, $providerId: ID, $pinned: Boolean, $read: Boolean) {
    updateChatbotConversation(id: $id, providerId: $providerId, pinned: $pinned, read: $read) {
      ...ChatbotConversationFields
    }
  }
`
